module.exports = __webpack_public_path__ + "assets/sms-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/sms-btn-icon.svg
// module id = 814
// module chunks = 0